import { BarChart3 } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { TravelAnalyticsRoutes } from "./routePaths";
import { TravelAnalyticsPermissions } from "./permissions";

/**
 * Travel Analytics Navigation Configuration
 *
 * Main navigation item with submenu for different analytics sections
 */
export const travelAnalyticsNav: INavItem = {
  labelKey: "nav.travel_analytics",
  icon: BarChart3,
  path: TravelAnalyticsRoutes.OVERVIEW,
  permissions: [TravelAnalyticsPermissions.VIEW],
  permissionPrefix: "Travel:Analytics:",
  children: [
    {
      labelKey: "nav.analytics_overview",
      path: TravelAnalyticsRoutes.OVERVIEW,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_flights",
      path: TravelAnalyticsRoutes.FLIGHTS,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_hotels",
      path: TravelAnalyticsRoutes.HOTELS,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_cars",
      path: TravelAnalyticsRoutes.CARS,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_performance",
      path: TravelAnalyticsRoutes.PERFORMANCE,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_funnel",
      path: TravelAnalyticsRoutes.FUNNEL,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_quality",
      path: TravelAnalyticsRoutes.QUALITY,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_providers",
      path: TravelAnalyticsRoutes.PROVIDERS,
      permissions: [TravelAnalyticsPermissions.PROVIDERS_VIEW],
    },
    {
      labelKey: "nav.analytics_geographic",
      path: TravelAnalyticsRoutes.GEOGRAPHIC,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
    {
      labelKey: "nav.analytics_searches",
      path: TravelAnalyticsRoutes.SEARCHES,
      permissions: [TravelAnalyticsPermissions.VIEW],
    },
  ],
};
